<div class="container-fluid">
  <p-table class="note-list-table"  #pt [value]="notes" [paginator]="displayPaginator()" [rows]="25" [rowsPerPageOptions]="[25,100,200]"
    [pageLinks]="3" [lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal"
    selectionMode="single" [(selection)]="note" [responsive]="true" sortMode="multiple" (onRowSelect)="onRowSelect($event)"
    [multiSortMeta]="multiSortMeta" dataKey="noteId" [loading]="loading" [scrollable]="true" scrollHeight="500px" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
    styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true" >

    <ng-template pTemplate="caption" >
      @if (!isPublicAndPublish) {
        <div class="d-block text-end justify-content-between align-items-center">
          <span class="note-btn d-flex">
            <!--clear filters-->
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
            <!--add new-->
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">Note +</button>
          </span>
        </div>
      }
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      <tr>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'title', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th><p-multiSelect [options]="statuses" displaySelectedLabel
        optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect></th>
        <th><p-multiSelect [options]="noteTypes" displaySelectedLabel
        optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'noteType', 'in')"></p-multiSelect></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:70px;" type="text"
      (input)="pt.filter($event.target.value, 'createDate', 'in')"></th> -->
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'lastUpdate', 'in')"></th> -->
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-note>
  <tr [pSelectableRow]="note" style="vertical-align:top">
    <td>{{note.createDate | date:'MM-dd-yyyy'}}</td>
    <td style="max-width: 40px; overflow: hidden;white-space: nowrap;">{{note.title}}</td>
    <td style="max-width: 40px; word-wrap: break-word; white-space: pre-wrap;" [innerHTML]="note?.description"></td>
    <td style="max-width: 40px; word-wrap: break-word; white-space: break-spaces !important;">{{note?.createdBy?.lastName?note?.createdBy?.lastName:''}} &nbsp;
    {{note?.createdBy?.firstName?note?.createdBy?.firstName:''}}</td>
    <td>{{note.status != undefined ? statuses[(note.status)].name : ''}}</td>
    <td>{{noteTypes[(note.noteType-1)].name}}</td>
    <td>{{note.lastUpdate | date:'MM-dd-yyyy'}}</td>
    @if (!isPublicAndPublish) {
      <td>
        <span style="padding-left:10px; float: right">
          <a>
            <mat-icon style="color:blue; font-size:110%" [pRowToggler]="note" (click)="onOpenFormEdit(note)">edit
            </mat-icon>
          </a>
        </span>
      </td>
    }
  </tr>
</ng-template>
</p-table>

</div>
